import { formatDateForFilename } from "@/src/lib/utils/date-and-phone-utils";
import {
  PriorAuthorizationStatus,
  PriorAuthorizationType,
} from "@/src/models/documents/prior-authorization/prior-authorization";
import {
  getAuthorizationStatusLabel,
  getAuthorizationTypeLabel,
} from "@/src/models/documents/prior-authorization/prior-authorization-display";
import { Patient } from "@/src/models/patient";

export function getNumberOfServicesText(num: number | null, type: PriorAuthorizationType | null): string {
  if (type !== PriorAuthorizationType.PROCEDURE || !num || num < 1) return "";

  return ` (${num} visit${num > 1 ? "s" : ""})`;
}

export function generatePatientName(patient: Patient | null): string {
  if (!patient) return "Unknown Patient";

  return `${patient.familyName?.toUpperCase()}_${patient.givenName?.toUpperCase()}`;
}

export function generatePriorAuthFilenameBase(
  patient: Patient | null,
  dateOfEvent: string | null,
  status: PriorAuthorizationStatus | null,
  type: PriorAuthorizationType | null,
  numberOfServices: number | null
): string {
  const patientName = patient ? generatePatientName(patient) + " - " : "";

  return `${patientName}${formatDateForFilename(dateOfEvent)} Auth ${getAuthorizationStatusLabel(status)} - ${getAuthorizationTypeLabel(type)}${getNumberOfServicesText(numberOfServices, type)}`;
}

/**
 * Sanitize a filename for ECW upload.
 * ECW rejects documents whose names contain em dashes or forward slashes.
 * Replace em dash (—) with a regular hyphen and forward slash with underscore.
 */
export function sanitizeEcwFilename(filename: string): string {
  return filename.replace(/[—–]/g, "-").replace(/\//g, "_");
}

export function generatePriorAuthFilename(
  patient: Patient | null,
  dateOfEvent: string | null,
  status: PriorAuthorizationStatus | null,
  type: PriorAuthorizationType | null,
  numberOfServices: number | null
): string {
  return `${generatePriorAuthFilenameBase(patient, dateOfEvent, status, type, numberOfServices)}.pdf`;
}
